import { render, staticRenderFns } from "./faultPage.vue?vue&type=template&id=2909ed43&scoped=true"
import script from "./faultPage.vue?vue&type=script&lang=js"
export * from "./faultPage.vue?vue&type=script&lang=js"
import style0 from "./faultPage.vue?vue&type=style&index=0&id=2909ed43&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2909ed43",
  null
  
)

export default component.exports